export var basic = {
  name: "车辆监控",
  path: "/monitor/car",
  hidden: false,
  redirect: "noredirect",
  component: "Layout",
  elemCode: "12",
  sort: 2,
  alwaysShow: true,
  meta: {
    title: "车辆监控",
    icon: "dashboard",
    noCache: false
  },
  children: [{
    name: "车辆监控",
    path: "/monitor/car",
    hidden: false,
    component: "basic/monitor/car/car",
    elemCode: "13",
    meta: {
      title: "车辆监控",
      noCache: true
    }
  }, {
    name: "车辆详情",
    path: "/monitor/car_info",
    hidden: true,
    component: "basic/monitor/car/info",
    elemCode: "14",
    meta: {
      title: "车辆详情",
      noCache: true
    }
  }]
};